export default defineAppConfig({
  ui: {
    colorMode: 'light',
    colors: {
      primary: 'trolleymate',
      neutral: 'trolleymate'
    },
    card: {
      slots: {
        root: 'overflow-hidden text-center bg-trolleymate-50 dark:bg-trolleymate-900 transition-all duration-300 hover:shadow-xl hover:-translate-y-2 hover:ring-2 hover:trolleymate-500 cursor-pointer shadow-md ',
        header:
          'bg-trolleymate-100 dark:bg-trolleymate-800 border-b border-trolleymate-200 dark:border-trolleymate-700',
        body: 'bg-trolleymate-50 dark:bg-trolleymate-900/50',
        footer: 'bg-trolleymate-100 dark:bg-trolleymate-800'
      }
    },
    tabs: {
      slots: {
        list: '',
        indicator: 'shadow-sm',
        trigger: ''
      }
    },
  }
})
